// extracted by mini-css-extract-plugin
export var quantityInput = "_pz-0";